// import { createSelector } from 'reselect';
import { defaultInitialState } from 'reducers/meta/apiReducerCreator';
import { defaultInitialState as listDefaultInitialState } from 'reducers/meta/listReducerCreator';

export const selectApiState = reducerKey => state =>
  state[reducerKey] || defaultInitialState;

export const selectListApiState = reducerKey => state =>
  state[reducerKey] || listDefaultInitialState;
